import React, { PureComponent } from "react";
import RoundEdit from "../components/round-edit";
import RoundNew from "../components/round-new";
import { getRequest, postRequest, patchRequest } from "../../api/ApiService";
import SweetAlert from "sweetalert-react";
import moment from "moment-timezone";
import { extractRoundErrorMessage } from "../utils/round-error";

class RoundManagement extends PureComponent {
  constructor(props) {
    super(props);

    const { location } = props;
    const pathes = location.pathname.split("/").filter(i => i !== "");
    let game_id = parseInt(pathes[2], 10);
    if (isNaN(game_id)) {
      game_id = props.game && props.game.id ? props.game.id : 0;
    }

    this.state = {
      is_loaded: false,
      current_round_number: null,
      game_id: game_id,
      game_name: "",
      course_name: "",
      rounds: [],
      errorAlert: false,
      errorText: "",
      successAlert: false,
      successText: "",
      new_round: {
        start_date: null,
        end_date: null
      }
    };
  }

  initNewRound = () => {
    this.setState({
      new_round: {
        start_date: null,
        end_date: null
      }
    });
  };

  showErrorAlert = () => {
    this.setState({
      errorAlert: true
    });
  };

  hideErrorAlert = () => {
    this.setState({
      errorAlert: false
    });
  };

  showError = errorText => {
    this.setState(
      {
        errorText
      },
      () => {
        this.showErrorAlert();
      }
    );
  };

  showSuccessAlert = () => {
    this.setState({
      successAlert: true
    });
  };

  hideSuccessAlert = () => {
    this.setState({
      successAlert: false
    });
  };

  showSuccess = successText => {
    this.setState(
      {
        successText
      },
      () => {
        this.showSuccessAlert();
      }
    );
  };

  createRound(data) {
    return postRequest(`${process.env.REACT_APP_API_URL}game/rounds/`).send(
      data
    );
  }

  updateRound(round_id, data) {
    return patchRequest(
      `${process.env.REACT_APP_API_URL}game/rounds/${round_id}/`
    ).send(data);
  }

  componentDidMount() {
    this.initNewRound();
    if (this.state.game_id !== 0) {
      this.fetchData();
    } else {
      this.fetchGameId();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.game_id === 0 && this.props.game && this.props.game.id) {
      this.setState({ game_id: this.props.game.id }, () => {
        this.fetchData();
      });
    }
  }

  fetchGameId() {
    getRequest(`${process.env.REACT_APP_API_URL}games/`)
      .then(res => {
        if (res.body && res.body.length > 0) {
          this.setState({ game_id: res.body[0].id }, () => {
            this.fetchData();
          });
        }
      })
      .catch(err => {});
  }

  fetchData() {
    const { game_id } = this.state;
    const requests = [];
    requests.push(
      getRequest(`${process.env.REACT_APP_API_URL}games/${game_id}/`)
    );
    requests.push(getRequest(`${process.env.REACT_APP_API_URL}courses/`));
    requests.push(getRequest(`${process.env.REACT_APP_API_URL}game/rounds/`));
    const joinRequest = Promise.all(requests);

    joinRequest
      .then(res => {
        const game = res[0].body;
        const game_name = game.name;
        const course = res[1].body.find(i => i.id === game.course);
        const course_name = course ? course.name : "";
        const rounds = res[2].body
          .filter(i => (game.rounds.includes(i.id) ? true : false))
          .map(i => ({
            id: i.id,
            number: i.number,
            start_date: moment(i.start_date),
            end_date: moment(i.end_date)
          }));

        let current_round_number = null;
        if (game.round !== null) {
          const current_round = rounds.find(i => i.id === game.round);
          if (current_round) {
            current_round_number = current_round.number;
          }
        }

        this.setState({
          game_name,
          course_name,
          rounds,
          current_round_number,
          is_loaded: true
        });
      })
      .catch(err => { });
  }

  onChange = (datetime, round_id, field) => {
    if (typeof datetime === "string") {
      return;
    }

    let rounds = [...this.state.rounds];
    let index = rounds.findIndex(i => i.id === round_id);

    if (index >= 0 && field in rounds[index]) {
      rounds[index][field] = datetime;

      this.setState({
        rounds
      });
    }
  };

  onChangeNew = (datetime, field) => {
    if (typeof datetime === "string") {
      return;
    }

    let new_round = { ...this.state.new_round };

    if (field in new_round) {
      new_round[field] = datetime;

      this.setState({
        new_round
      });
    }
  };

  onUpdate = round_id => {
    const { game_id } = this.state;
    const round = this.state.rounds.find(i => i.id === round_id);

    if (round.number <= this.state.current_round_number) {
      this.showError(
        "The game has been started! You cannot update current or previous rounds!"
      );
      return;
    }

    const round_number = round.number;

    let start_date = round.start_date.utc();
    let end_date = round.end_date.utc();

    if (
      start_date.valueOf() <
      moment()
        .utc()
        .valueOf()
    ) {
      this.showError("Start time cannot be less than now!");
      return;
    }

    if (
      end_date.valueOf() <
      moment()
        .utc()
        .valueOf()
    ) {
      this.showError("End time cannot be less than now!");
      return;
    }

    console.log('start_date before', start_date);
    start_date = start_date.toISOString();
    console.log('start_date after', start_date);
    end_date = end_date.toISOString();

    this.setState({
      is_loaded: false
    });

    this.updateRound(round_id, {
      number: round_number,
      type: 1,
      start_date,
      end_date,
      game: game_id
    })
      .then(res => {
        this.fetchData();
      })
      .catch(err => {
        this.setState({
          is_loaded: true
        });

        this.showError(
          extractRoundErrorMessage(err)
            || "Unable to update the round. Please try again."
        );
      });
  };

  onAdd = round_number => {
    const { game_id } = this.state;
    const round = { ...this.state.new_round };

    if (round.start_date === null || round.end_date === null) {
      this.showError("All fields required!");
      return;
    }

    let start_date = round.start_date.utc();
    let end_date = round.end_date.utc();

    if (
      start_date.valueOf() <
      moment()
        .utc()
        .valueOf()
    ) {
      this.showError("Start time cannot be less than now!");
      return;
    }

    if (
      end_date.valueOf() <
      moment()
        .utc()
        .valueOf()
    ) {
      this.showError("End time cannot be less than now!");
      return;
    }

    start_date = start_date.toISOString();
    end_date = end_date.toISOString();

    this.setState({
      is_loaded: false
    });

    this.createRound({
      number: round_number,
      type: 1,
      start_date,
      end_date,
      game: game_id
    })
      .then(res => {
        this.initNewRound();
        this.fetchData();
      })
      .catch(err => {
        this.setState({
          is_loaded: true
        });

        this.showError(
          extractRoundErrorMessage(err)
            || "Unable to create the round. Please try again."
        );
      });
  };

  render() {
    const {
      rounds,
      new_round,
      is_loaded,
      errorAlert,
      errorText,
      successAlert,
      successText,
      game_name,
      course_name
    } = this.state;

    return (
      <section className="instructorPage">
        <SweetAlert
          show={errorAlert}
          title="Error"
          text={errorText}
          type="error"
          onConfirm={this.hideErrorAlert}
        />
        <SweetAlert
          show={successAlert}
          title="Success"
          text={successText}
          type="success"
          onConfirm={this.hideSuccessAlert}
        />
        <h1>Round Management</h1>
        <div className="instructorWrapper">
          <b style={{ fontSize: "20px" }}>Course: {course_name}</b>
          <br />
          <b style={{ fontSize: "20px" }}>Game: {game_name}</b>
          <br />
          <br />
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th className="text-center instructor-table-th">Round</th>
                  <th className="text-center instructor-table-th">
                    Start Time
                  </th>
                  <th className="text-center instructor-table-th">End Time</th>
                  <th className="text-center instructor-table-th"></th>
                </tr>
              </thead>
              <tbody>
                {is_loaded === false ? (
                  <tr>
                    <td
                      colSpan="4"
                      className="text-center v-align-middle instructor-td"
                    >
                      Loading...
                    </td>
                  </tr>
                ) : (
                  rounds.map((round, i) => (
                    <RoundEdit
                      key={i}
                      round={round}
                      onChange={this.onChange}
                      onUpdate={this.onUpdate}
                    />
                  ))
                )}
                {is_loaded === true && (
                  <RoundNew
                    round_number={rounds.length + 1}
                    round={new_round}
                    onChange={this.onChangeNew}
                    onAdd={this.onAdd}
                  />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    );
  }
}

export default RoundManagement;



// WEBPACK FOOTER //
// ./src/instructor/containers/round-management.js